import { ReactNode, lazy, Suspense } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileActionBar from './MobileActionBar';
import ScrollToTop from '@/components/ui/ScrollToTop';
import InstallPWAButton from '@/components/pwa/InstallPWAButton';
import CookieConsent from '@/components/consent/CookieConsent';

import { useLanguage } from '@/contexts/LanguageContext';

const ChatBot = lazy(() => import('@/components/chat/ChatBot'));

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col min-h-screen">
      {/* Skip to content */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-accent focus:text-accent-foreground focus:px-4 focus:py-2 focus:rounded-md focus:font-semibold">
        {t('a11y.skipToContent')}
      </a>
      <Header />
      <main id="main-content" className="flex-1 pb-[calc(env(safe-area-inset-bottom)+64px)] md:pb-0">
        {children}
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ChatBot />
      </Suspense>
      <ScrollToTop />
      <InstallPWAButton />
      <MobileActionBar />
      <CookieConsent />

    </div>
  );
};

export default Layout;
